export default __webpack_public_path__ + "static/media/timer-icon.e6096053.svg";